// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

export function setFieldId(
  ydb: Database,
  fieldId: string,
  settingsFieldId: string
): void {
  ydb.mutate((db) => {
    db.fieldsById[fieldId].fieldId = settingsFieldId;
  });
}
